module.exports = __webpack_public_path__ + "static/img/10.fe349e8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/10.jpeg
// module id = zIop
// module chunks = 3